<template>
  <div id="fake-select-wrap">
    <div class="fake-select-backdrop" :class="{ 'open': isOpen, 'is-compact': compact }" @click="toggle" />
    <div ref="select" class="fake-select scrollFix" :class="{ 'open': isOpen, 'is-compact': compact, 'disabled': disabled }" v-on="$listeners">
      <div class="fake-select-title" @click="toggle">
        <div v-if="centered" class="spacer" />
        <span class="text">
          {{ title }}
        </span>
        <span class="icon">
          <img :src="$icon('caret-down')">
        </span>
      </div>
      <div ref="list" class="fake-select-options">
        <div v-if="reset" class="fake-select-option fake-select-option-reset" :class="{ 'active': selected === null }" @click="selected = null">
          {{ reset }}
        </div>
        <slot>
          <div v-for="(opt, i) in options" :key="i" :class="{ 'active': selected && selected.id === opt.id }" class="fake-select-option" @click="selected = opt">
            {{ opt.name }} {{ opt.city ? `- ${opt.city}` : null }} 
            <template v-if="opt.street">
              {{ isDuplicatedGarage(opt) ? `- ${opt.street}` : null }}
            </template>
          </div>
        </slot>
      </div>
    </div>
    <div v-if="errors.length" class="select-errors">
      <div v-for="(error, i) in errors" :key="i" class="pl-3 invalid-feedback d-block">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FakeSelect',
  props: {
    button: {
      type: Boolean,
      required: false,
      default: false
    },
    centered: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    model: {
      required: false,
      validator: (v) => typeof v === 'object',
      default: null
    },
    options: {
      type: Array,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: true
    },
    reset: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      isOpen: false,
      filteredGarages: []
    }
  },
  computed: {
    title () {
      return this.selected ? this.selected.name + (this.selected.city ? ` - ${this.selected.city}` : '') : this.placeholder
    },
    selected: {
      get () {
        return this.model
      },
      set (val) {
        this.isOpen = false
        this.$emit('update:model', val)
        this.$emit('change', val)
      }
    }
  },
  methods: {
    toggle () {
      if (this.disabled || this.button) {
        return
      }

      this.isOpen = !this.isOpen

      if(this.options[0] && this.options[0].street) {
        const garagesArr = this.options.map(garage => garage.name);

        this.filteredGarages = garagesArr.filter(function(item, idx) { 
            return garagesArr.indexOf(item) != idx 
        });
      }

      if (this.isOpen) {
        const rect = this.$el.getBoundingClientRect()
        const h = window.innerHeight - rect.height - rect.top - 15
        
        this.$refs.list.style.maxHeight = `${h}px`   
      }
    },
    isDuplicatedGarage(garage) {
      return this.filteredGarages.some(garageName => garageName == garage.name)
    }
  }
}
</script>